import { useEffect, useState } from 'react';

const ARKOSE_RUN_TIMEOUT = 5000;

type ArkoseCompleteEvent = Event & {
  detail: {
    arkoseToken: string;
  };
};

function useArkose(): {
  arkoseComplete: boolean;
  runArkose: () => Promise<string>;
  removeArkose: () => void;
} {
  const [arkoseComplete, setArkoseComplete] = useState<boolean>(false);
  const [firedArkoseCompleteTrigger, setFiredArkoseCompleteTrigger] = useState<
    boolean
  >(false);

  useEffect(() => {
    window.setupEnforcement = setupEnforcement;
  });

  const setupEnforcement = (enforcementObject: any) => {
    window.Arkose = enforcementObject;

    window.Arkose.setConfig({
      onCompleted: function (response: { token: string }) {
        setArkoseComplete(true);

        if (!firedArkoseCompleteTrigger) {
          const event: ArkoseCompleteEvent = new window.CustomEvent(
            'arkoseCompleted',
            {
              detail: {
                arkoseToken: response.token,
              },
            }
          );
          window.dispatchEvent(event);
          setFiredArkoseCompleteTrigger(true);
        }
      },
    });
  };

  const runArkoseWithTimeout = (reject: (error?: any) => void) => {
    window.Arkose.run();

    function timeoutReject() {
      reject(new Error('arkose time out.'));
    }

    setTimeout(timeoutReject, ARKOSE_RUN_TIMEOUT);
  };

  const runArkose = async (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      function resolveArkose(arkoseResult: ArkoseCompleteEvent) {
        resolve(arkoseResult.detail.arkoseToken);
      }
      window.addEventListener('arkoseCompleted', resolveArkose);

      runArkoseWithTimeout(reject);
    });
  };

  const removeArkose = () => {
    const arkoseScript = document.getElementById('arkosescript');
    if (arkoseScript) {
      arkoseScript.remove();
    }
  };

  return {
    arkoseComplete,
    runArkose,
    removeArkose,
  };
}

export default useArkose;
